import { matchPath } from 'react-router-dom';

export function matchRoutePattern<T>(
  map: Record<string, T>,
  pathname: string,
): { pattern: string; entry: T; params: Record<string, string | undefined> } | undefined {
  const patterns = Object.entries(map).sort(([a], [b]) => b.split('/').length - a.split('/').length);

  for (const [pattern, entry] of patterns) {
    const match = matchPath(pattern, pathname);
    if (match) return { pattern, entry, params: match.params };
  }

  return undefined;
}
